const SUPPORTED_LANGUAGE = /^(fr|en|ar|ru|kk)(-.*)?/i

export const languageFromParam = (lang: unknown): string[] | undefined =>
  typeof lang === 'string' && SUPPORTED_LANGUAGE.test(lang)
    ? lang.toLowerCase().split('-')
    : undefined

export const toI18nLanguage = (language: string | string[]): string => {
  if (language.includes('fr')) return 'fr'
  if (language.includes('ar')) return 'ar'
  if (language.includes('ru')) return 'ru-RU'
  if (language.includes('kk')) return 'kk-KZ'
  return 'en'
}
